import { useAuthStore } from "@/stores";
import { getMockData } from "@/services/mockApi";
import { createApiClient } from "@core/http";
import { currentDefaultVersion } from "@/assets/mobiusVersioningData";

const SERVICE_URLS = {
  cwacc: `/api/cwacc/${currentDefaultVersion}`,
  psa: "/api/psa",
  branding: "/api/branding",
  "tenant-branding": "/api/tenant-branding",
  payments: "/api/payments",
  statuses: "/api/statuses",
  "tenant-management": "/api/tenant-management"
};

// NOTE: Mobius is served from the same origin as its API, so the client needs no base URL.
const client = createApiClient({
  servicePaths: SERVICE_URLS,
  authFetch: () => useAuthStore().authFetch,
  resolveMock: (service, path) => getMockData(service, path)
});

export const { fetchPage, postPage, deletePage } = client;
